import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

/*
 MODELS
 */
import {Attachment} from '../models/attachment.model';
import {City} from '../models/city.model';
import {ContactForm} from '../models/contact-form.model';
import {Project} from '../models/project.model';
import {User} from '../models/user.model';
import {UserRole} from '../models/user-role.model';
import {MrpResponse} from '../interfaces/interfaces';
import {HttpErrorResponse, HttpEventType, HttpParams} from '@angular/common/http';
import {Pagination} from '../models/query/pagination.model';
import {catchError, map} from 'rxjs/operators';
import {ToastService} from '../../services/toast/toast.service';
import {Toast} from '../../services/toast/toast.model';
import {ConfigService} from '../../services/config/config.service';
import {AuthHttpService} from '../../services/http/auth-http.service';
import {debounceTime} from 'rxjs/operator/debounceTime';

@Injectable()
export class EloquentManagerService {


    private apiBaseUrl: string = this.configService.get('apiBaseUrl');

    constructor(private configService: ConfigService,
                private authHttp: AuthHttpService,
                private toastService: ToastService) {

    }


    private getApiPrefix(model: any) {
        const apiPrefix = model.API_PREFIX;
        if (apiPrefix == null) {
            throw Observable.throw('API_PREFIX property is not defined in the model: ${model.name}');
        }
        return apiPrefix;
    }


    public list(model: any): any {

        return this.authHttp.authGet(this.apiBaseUrl + this.getApiPrefix(model), {}).pipe(
            map((response: MrpResponse) => {
                if (response.ok) {
                    const modelList = [];
                    const responseArray = response.body;
                    for (let i = 0; i < responseArray.length; i++) {
                        modelList.push(new model().deserialize(responseArray[i]));
                    }

                    return modelList;
                } else {
                    return Observable.of(false);

                }
            }),
            catchError(err => {
                console.log(err);
                return Observable.of(false);
                }
            )
        );
    }


    public paginate(model: any, pagination: Pagination): any {

        const url = this.apiBaseUrl + this.getApiPrefix(model) + '/paginate';
        return this.authHttp.authPost(url, {pagination}).pipe(
            map((response: MrpResponse) => {
                if (response.ok) {
                    const modelList = [];
                    const responseArray = response.body.data;

                    for (let i = 0; i < responseArray.length; i++) {
                        modelList.push(new model().deserialize(responseArray[i]));
                    }

                    response.body.data = modelList;

                    return response.body;
                } else {
                    return Observable.of(false);

                }
            }),
            catchError(err => {
                return Observable.of(false);
            })
        );
    }

    public getById(model: any, id: number): any {
        return this.authHttp.authGet(this.apiBaseUrl + this.getApiPrefix(model) + '/' + id, {}).pipe(
            map((response: MrpResponse) => {

                if (response.ok) {
                    return new model().deserialize(response.body);
                }
            }),
            catchError((error) => {
                return Observable.of(false);
            })
        );
    }

    public save(model: any) {

        const savingToast = this.toastService.saving();


        return this.authHttp.authPost(this.apiBaseUrl + model.getApiPrefix(), model).pipe(
            map((response: MrpResponse) => {
                if (response.ok) {
                    console.log(response);
                    this.toastService.saved(savingToast);
                    return model.deserialize(response.body);
                }
            }),
            catchError((error) => {
                this.toastService.saveFailed(savingToast);
                return Observable.of(false);
            })
        );
    }

    public update(model: any) {

        const savingToast = this.toastService.saving();


        const url = this.apiBaseUrl + model.getApiPrefix() + '/' + model.id;

        return this.authHttp.authPut(url, model).pipe(
            map((response: Response) => {
                if (response.ok) {
                    this.toastService.saved(savingToast);
                    return Observable.of(true);
                }
            }),
            catchError((error) => {
                this.toastService.saveFailed(savingToast);
                return Observable.of(false);
            })
        );
    }


    public delete(model: any) {

        const deletingToast = this.toastService.deleting();


        const url = this.apiBaseUrl + model.getApiPrefix() + '/' + model.id;

        return this.authHttp.authDelete(url).pipe(
            map((response: Response) => {
                if (response.ok) {
                    this.toastService.saved(deletingToast);
                    return Observable.of(true);
                }
            }),
            catchError((error) => {
                this.toastService.saveFailed(deletingToast);
                return Observable.of(false);
            })
        );
    }

    public attach(model: any, attachment: File) {
        /*if (!attachment.validate()) {
         this.validationFailedNotification(notification);
         return Observable.of(false);
         }*/

        const input = new FormData();
        input.append('file', attachment);

        const url = this.apiBaseUrl + model.getApiPrefix() + '/' + model.id + '/attach';

        return this.authHttp.attach(url, input).pipe(
            map((event) => {
                return event;

            }),
            catchError((error) => {
                this.toastService.error('Hata Oluştu', `Beklenmeyen bir hatayla karşılaşıldı<br/><br/>Hata Kodu: ${error}`);
                return Observable.of(false);
            })
        );
    }


    public detach(attachment: Attachment) {

        const url = this.apiBaseUrl + attachment.getApiPrefix() + '/' + attachment.id + '/detach';

        return this.authHttp.authPut(url).pipe(
            map((response) => {
                return response;
            }),
            catchError((error) => {
                this.toastService.error('Hata Oluştu', `Beklenmeyen bir hatayla karşılaşıldı<br/><br/>Hata Kodu: ${error}`);
                return Observable.of(false);
            })
        );
    }

    public request(method: string, url: string, data?: any) {

        let authMethod;

        switch (method) {
            case 'POST': {
                authMethod = this.authHttp.authPost;
                break;
            }
            case 'PUT': {
                authMethod = this.authHttp.authPut;
                break;
            }
            case 'GET': {
                authMethod = this.authHttp.authGet;
                break;
            }
            case 'DELETE': {
                authMethod = this.authHttp.authDelete;
                break;
            }
            default: {
                authMethod = this.authHttp.authGet;
                break;
            }
        }


        return authMethod(url, data).pipe(
            map((response: MrpResponse) => {
                if (response.ok) {
                    return response.body;
                } else {
                    return Observable.of(false);

                }
            }),
            catchError(err => {
                    return Observable.of(false);
                }
            )
        );
    }
}




// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/shared/eloquent/providers/eloquent-manager.provider.ts